// Sentry metrics
export const SentryScope = {
    collection: {
        id: "collection.id",
        merchantId: "collection.merchant_id",
    },
};

// Use this function for to add variables, like if a tab switch, specify which tab is loading
export const specifyAssortmentTransaction = (transaction: AssortmentTransactions, ...rest) => {
    return transaction + rest.map((detail: string) => ` {${detail}}`).join();
};

export enum AssortmentTransactions {
    OpenCDP = "ASSORTMENT: OPEN CDP",
    CDPTabChange = "ASSORTMENT: CDP TAB CHANGE",
    PinColumn = "ASSORTMENT: PIN COLUMN FROM CONTEXT MENU",
    AddColumn = "ASSORTMENT: ADD COLUMN FROM TOOL PANEL",
    MoveColumn = "ASSORTMENT: REODER COLUMNS",
    Mutate = "ASSORTMENT: MUTATE",
    MutateAllocationBag = "ASSORTMENT: MUTATE ALLOCATION BAG",
    ResizeColumn = "ASSORTMENT: COLUMN RESIZED",
    SaveView = "ASSORTMENT: SAVE VIEW",
    SwitchView = "ASSORTMENT: SWITCH VIEW",
    Search = "ASSORTMENT: SEARCH",
}

export enum AssortmentEvents {
    ResizeColumn = "ASSORTMENT: REQUEST TO RESIZE COLUMN",
    PinColumn = "ASSORTMENT: REQUEST TO PIN COLUMN FROM CONTEXT MENU",
    AddColumn = "ASSORTMENT: COLUMN CHECKBOX CLICKED (CHECKED)",
    MoveColumn = "ASSORTMENT: REQUEST TO REORDER COLUMNS",
    SaveView = "ASSORTMENT: REQUEST TO SAVE VIEW",
    SwitchView = "ASSORTMENT: REQUEST TO SWITCH VIEW",
    MutateCalculateTotals = "ASSORTMENT: MUTATE CALCULATE TOTALS",
    MutatePendingMutations = "ASSORTMENT: MUTATE PENDING MUTATIONS",
    MutateEnhanced = "ASSORTMENT: MUTATE ENHANCED",
    MutateRequest = "ASSORTMENT: MUTATE REQUEST",
    Search = "ASSORTMENT: SEARCH",
}
